import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { createRoleStore } from "./roleStoreFactory";

export const useStore = create(
  persist(
    (set) => ({
      /* ----------------------------------
       * Hydration lifecycle
       * ---------------------------------- */
      isHydrating: true,
      finishHydration: () => set({ isHydrating: false }),

      /* ----------------------------------
       * Shared, role-agnostic state
       * ---------------------------------- */
      userLocation: {
        lat: 17.385,
        lng: 78.4867,
        city: "Germany",
      },

      setUserLocation: ({ lat, lng, city }) => {
        try {
          localStorage.setItem("userLat", String(lat));
          localStorage.setItem("userLng", String(lng));
          localStorage.setItem("userLocation", city || "");
        } catch {}
        set({ userLocation: { lat, lng, city } });
      },

      basicSettings: null,
      followers: null,

      EventOrderDetails: null,
      MovieOrderDetails: null,
      orderDetails: null,

      /* ----------------------------------
       * Mutators only (no side effects)
       * ---------------------------------- */
      setBasicSettings: (data) => set({ basicSettings: data }),
      setFollowers: (data) => set({ followers: data }),

      setEventOrderDetails: (data) => set({ EventOrderDetails: data }),
      setMovieOrderDetails: (data) => set({ MovieOrderDetails: data }),
      setOrderDetails: (data) => set({ orderDetails: data }),

      preregUnlockData: null,
      setPreregUnlockData: (data) => set({ preregUnlockData: data }),
    }),
    {
      name: "app-storage",
      storage: createJSONStorage(() => sessionStorage),
      onRehydrateStorage: () => (state) => {
        state?.finishHydration?.();
      },
    }
  )
);

export const checkSession = () => {
  const { verifySession } = useStore.getState();
  verifySession();
};

export const likedData = create(
  persist(
    (set) => ({
      likedEvents: [],
      setLikedEvents: (data) => set({ likedEvents: data }),
      updateLikedEvents: (data) =>
        set((state) => ({ likedEvents: [...state.likedEvents, data] })),
      removeLikedEvents: (data) =>
        set((state) => ({
          likedEvents: state.likedEvents.filter((item) => item.id !== data.id),
        })),

      likedMovies: [],
      setLikedMovies: (data) => set({ likedMovies: data }),
      updateLikedMovies: (data) =>
        set((state) => ({ likedMovies: [...state.likedMovies, data] })),
      removeLikedMovies: (data) =>
        set((state) => ({
          likedMovies: state.likedMovies.filter((item) => item.id !== data.id),
        })),
    }),
    {
      name: "liked-storage",
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);

export const reviewsData = create((set) => ({
  reviews: [],
  setReviews: (data) => set({ reviews: data }),
  updateReviews: (data) =>
    set((state) => ({ reviews: [...state.reviews, data] })),
}));

export const useAdminStore = createRoleStore("admin");
export const useOrganizerStore = createRoleStore("organizer");
export const useAttendeeStore = createRoleStore("attendee");
export const useScannerStore = createRoleStore("scanner");
